module.exports = __webpack_public_path__ + "img/banner-jp.3ef56faf.png";